import {
  CreatePushType,
  DirectPushType,
  SchedulePushType,
  SearchPushQueryType,
  UpdatePushType,
} from 'types';
import { base } from './';

const PATH = '/push-message';

const getAll = (filter: SearchPushQueryType) =>
  base.get(PATH, { params: { ...filter } });

const get = (id: string) => base.get(`${PATH}/${id}`);

/** 예상 발송 대상 수 */
const getTargetCount = () => base.get(`${PATH}/target-count`);

/** 작성(임시저장). 발송은 send / schedule 로 분리돼 있다. */
const post = (data: CreatePushType) => base.post(PATH, data);

const put = ({ id, ...data }: UpdatePushType) =>
  base.put(`${PATH}/${id}`, data);

const send = (id: number) => base.post(`${PATH}/${id}/send`);

const schedule = ({ id, sendAt }: SchedulePushType) =>
  base.post(`${PATH}/${id}/schedule`, { sendAt });

const cancel = (id: number) => base.post(`${PATH}/${id}/cancel`);

/** 특정 회원 대상 즉시 발송 (행사 상세 참여자 알림 모달) */
const postDirect = (data: DirectPushType) => base.post(`${PATH}/direct`, data);

const postFeedbackNotification = (id: number) =>
  base.post(`enroll-response/${id}/feedback-notification`);

export {
  getAll,
  get,
  getTargetCount,
  post,
  put,
  send,
  schedule,
  cancel,
  postDirect,
  postFeedbackNotification,
};
